(function(){
'use strict';
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var fine = window.matchMedia('(pointer:fine)').matches;
var CDN = 'https://cdn.shopify.com/s/files/1/0747/7490/4998/files/';
/* media/… はShopifyテーマ上ではasset_urlに差し替わる(window.TRACE_V8_MEDIA) */
function MU(p){ var m = window.TRACE_V8_MEDIA; return (m && m[p]) || p; }
/* ローカル画像(media/…)はCDNを付けない */
function imgURL(f){ return f.indexOf('/') > -1 ? MU(f) : CDN + f; }

/* ---------- reveal (runs first) ---------- */
(function(){
  var els = document.querySelectorAll('.rv');
  if (!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in')}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, {threshold:.18});
  els.forEach(function(e){ io.observe(e); });
})();

/* ---------- lenis (optional smoothness) ---------- */
if (!reduced && typeof Lenis !== 'undefined' && typeof gsap !== 'undefined'){
  var lenis = new Lenis({ duration: 1.1, smoothWheel: true });
  gsap.ticker.add(function(t){ lenis.raf(t * 1000); });
  gsap.ticker.lagSmoothing(0);
}

/* ---------- 商品データ (live Shopify variants, 2026-08-06) ---------- */
var HO = {"heritage": {"colors": {"silver": {"name": "Silver", "hex": "#C9CCD0", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-007_silver_1_main_4a96f985-c12d-4055-a57e-8d2c297776c9.png", "media/front_h_silver.jpg", "TR-007_silver_2_side_976b586f-5411-4f57-8a12-d058ce35afee.png", "TR-007_silver_3_back_8f4b7962-d1d7-4030-b58d-41eb3ba6c1f1.png", "TR-007_silver_4_open.png"], "vids": {"XS": "56731300167846", "S": "56731300200614", "M": "56731300233382", "L": "56731300266150", "XL": "56731300298918"}}, "white": {"name": "White", "hex": "#F2F1ED", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-007_white_1_main_3218a178-d13e-4648-94c9-8341ba00795e.png", "media/front_h_white.jpg", "TR-007_white_2_side_eaced780-8d08-436e-a316-e99e24ea26bd.png", "TR-007_white_3_back_ca4ed640-60d7-4f9d-93b2-248b8173ad9e.png", "TR-007_white_4_open.png"], "vids": {"XS": "56731300004006", "S": "56731300036774", "M": "56731300069542", "L": "56731300102310", "XL": "56731300135078"}}, "black": {"name": "Black", "hex": "#1C1C1E", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-007_black_1_main_7310cb68-f0c0-401a-ad7e-8d0393219efd.png", "media/front_h_black.jpg", "TR-007_black_2_side_f42118a4-1938-42c2-878c-81608499b9fa.png", "TR-007_black_3_back_8d0e9bce-e4de-48d5-868b-95c88dcad165.png", "TR-007_black_4_open.png"], "vids": {"XS": "56731300331686", "S": "56731300364454", "M": "56731300397222", "L": "56731300429990", "XL": "56731300462758"}}, "spacegray": {"name": "Space Gray", "hex": "#6E7073", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-007_spacegray_1_main.png", "media/front_h_spacegray.jpg", "TR-007_spacegray_2_side_3c36cacc-24ad-4b80-b294-5d5660224e18.png", "TR-007_spacegray_3_back_9d55c7ce-5e6e-45fd-a739-d11bb5f77625.png", "TR-007_spacegray_4_open.png"], "vids": {"XS": "56731300495526", "S": "56731300528294", "M": "56731300561062", "L": "56731300593830", "XL": "56731300626598"}}, "olive": {"name": "Olive", "hex": "#6B6F5A", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-007_olive_1_main_322f0c3d-3104-4568-81d6-bce267bad3fc.png", "media/front_h_olive.jpg", "TR-007_olive_2_side_f0e7cbe0-3ed0-4c2f-bce6-47b369d8d582.png", "TR-007_olive_3_back_3be83690-5b62-4b1a-b7c2-4ceb3a9b1bcf.png", "TR-007_olive_4_open.png"], "vids": {"XS": "56731300659366", "S": "56731300692134", "M": "56731300724902", "L": "56731300757670", "XL": "56731300790438"}}, "rosegold": {"name": "Rose Gold", "hex": "#D9A9A0", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-007_rosegold_1_main.png", "media/front_h_rosegold.jpg", "TR-007_rosegold_2_side_9694945e-bba9-4454-bcd2-8acad0184d92.png", "TR-007_rosegold_3_back_9fd26a15-d100-4965-abbd-80ee52e87982.png", "TR-007_rosegold_4_open.png"], "vids": {"XS": "56731300823206", "S": "56731300855974", "M": "56731300888742", "L": "56731300921510", "XL": "56731300954278"}}, "winered": {"name": "Wine Red", "hex": "#6E2B33", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-007_winered_1_main.png", "media/front_h_winered.jpg", "TR-007_winered_2_side_cad4589b-eb0a-4baf-8693-207d4818d153.png", "TR-007_winered_3_back_39e7a940-cf2d-44ae-9bca-7df1cc540a08.png", "TR-007_winered_4_open.png"], "vids": {"XS": "56731300987046", "S": "56731301019814", "M": "56731301052582", "L": "56731301085350", "XL": "56731301118118"}}, "yellow": {"name": "Yellow", "hex": "#E6C24D", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-007_yellow_1_main.png", "media/front_h_yellow.jpg", "TR-007_yellow_2_side_4ddec181-4f96-460e-ad9f-90f9690d2cf1.png", "TR-007_yellow_3_back_47039aa9-177a-41c7-9d2d-cdfc21dc9477.png", "TR-007_yellow_4_open.png"], "vids": {"XS": "56731301150886", "S": "56731301183654", "M": "56731301216422", "L": "56731301249190", "XL": "56731301281958"}}}}, "odyssey": {"colors": {"silver": {"name": "Silver", "hex": "#C9CCD0", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-002_silver_1_main.png", "media/front_o_silver.jpg", "TR-002_silver_2_side.png", "TR-002_silver_3_back.png", "TR-002_silver_4_open_5c9c7e20-05e0-4938-b871-affd36a47f9c.png"], "vids": {"XS": "56731279163558", "S": "56731279196326", "M": "56731279229094", "L": "56731279261862", "XL": "56731279294630"}}, "white": {"name": "White", "hex": "#F2F1ED", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-002_white_1_main.png", "media/front_o_white.jpg", "TR-002_white_2_side.png", "TR-002_white_3_back.png", "TR-002_white_4_open.png"], "vids": {"XS": "56731278999718", "S": "56731279032486", "M": "56731279065254", "L": "56731279098022", "XL": "56731279130790"}}, "black": {"name": "Black", "hex": "#1C1C1E", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-002_black_1_main.png", "media/front_o_black.jpg", "TR-002_black_2_side.png", "TR-002_black_3_back.png", "TR-002_black_4_open.png"], "vids": {"XS": "56731279327398", "S": "56731279360166", "M": "56731279392934", "L": "56731279425702", "XL": "56731279458470"}}, "gray": {"name": "Gray", "hex": "#8A8D91", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-002_gray_1_main.png", "media/front_o_gray.jpg", "TR-002_gray_2_side.png", "TR-002_gray_3_back.png", "TR-002_gray_4_open.png"], "vids": {"XS": "56731279491238", "S": "56731279524006", "M": "56731279556774", "L": "56731279589542", "XL": "56731279622310"}}, "blue": {"name": "Blue", "hex": "#3E5A78", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-002_blue_1_main.png", "media/front_o_blue.jpg", "TR-002_blue_2_side.png", "TR-002_blue_3_back.png", "TR-002_blue_4_open.png"], "vids": {"XS": "56731279655078", "S": "56731279687846", "M": "56731279720614", "L": "56731279753382", "XL": "56731279786150"}}, "green": {"name": "Green", "hex": "#4A5D50", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-002_green_1_main.png", "media/front_o_green.jpg", "TR-002_green_2_side.png", "TR-002_green_3_back.png", "TR-002_green_4_open.png"], "vids": {"XS": "56731279818918", "S": "56731279851686", "M": "56731279884454", "L": "56731279917222", "XL": "56731279949990"}}, "pink": {"name": "Pink", "hex": "#E3B7BD", "sizes": ["XS", "S", "M", "L", "XL"], "imgs": ["TR-002_pink_1_main.png", "media/front_o_pink.jpg", "TR-002_pink_2_side.png", "TR-002_pink_3_back.png", "TR-002_pink_4_open.png"], "vids": {"XS": "56731279982758", "S": "56731280015526", "M": "56731280048294", "L": "56731280081062", "XL": "56731280113830"}}}}};

var PRODUCTS = {
  meridian: {
    key: 'meridian', title: 'MERIDIAN', kicker: 'Flagship — Aluminum-frame suitcase',
    sub: '立てたまま、必要なものへ。', detTitle: '旅の動作から、逆算した。',
    lead: 'ケースを寝かせずに小物を出し入れできる、フロントオープンのスーツケース。ホテルのロビーでも、移動の合間でも。',
    benefits: [
      ['立てたまま、小物を取り出す', '前面を開けて出し入れできる、フロントオープン収納。'],
      ['待ち時間に、カップの置き場所を', '使う時だけ引き出せる、折りたたみカップホルダー。'],
      ['進む方向に合わせて、向きを変える', '360°回転する8輪のダブルキャスター。']
    ],
    handle: 'trace-meridian', soldout: false,
    hasOpen: true, hasPack: true, journey: true, sizeFig: true, capCol: true,
    v3sub: 'ドラッグで実物を360°回す。<br>開けて、詰めて、旅の荷物が入るかたしかめてください。',
    spinPrefix: '',
    clips: [['media/clip_frontopen.mp4', 'Front open — 立てたまま、開ける'],
            ['media/clip_wheels.mp4', '8 wheels — 静音ダブルキャスター']],
    fallback: { silver:'media/front_silver.jpg', black:'media/front_black.jpg', white:'media/front_ivory.jpg',
                gunmetal:'media/front_gunmetal.jpg', darkgreen:'media/front_darkgreen.jpg', whiteorange:'media/front_whiteorange.jpg' },
    prices: {XS:'¥27,800', S:'¥29,800', M:'¥31,800', L:'¥32,800', XL:'¥33,800'},
    sharedImgs: ['media/int_pockets.jpg', 'media/int_divider.jpg', 'media/int_front.jpg'],
    table: {
      XS: ['約57×39×24cm', '約3.6kg', '約45L'], S: ['約66×46×28cm', '約4.3kg', '約65L'],
      M: ['約73×50×31cm', '約4.8kg', '約80L'], L: ['約73×42×35cm', '約6.4kg', '約98L'],
      XL: ['約75×43×37cm', '約6.8kg', '約110L']
    },
    dims: {XS:{h:57,cap:45}, S:{h:66,cap:65}, M:{h:73,cap:80}, L:{h:73,cap:98}, XL:{h:75,cap:110}},
    sizeNote: '※寸法は高さ×幅×厚（車輪・ハンドル含む／手測り±1〜2cm）。Dark Green・White/OrangeはXS・S・Mのみの展開です。<br>※XSは3辺合計120cmです。全サイズが一般的な機内持込基準の3辺合計115cmを超えるため、機内持込対応とはご案内していません。ご搭乗前に各航空会社のサイズ・重量規定をご確認ください。<br>※写真の縮尺比は目安です。寸法は表の数値をご確認ください。',
    features: [
      ['立てたまま、前面から取り出す', '立てたまま前面を開き、小物を取り出せます。L・XLは内側にファスナー付きのPC収納があり、17.3インチまでのノートPCに対応します。XS・S・MのPC収納対応寸法は確認できていません。※機種の外寸やケースの厚みにより収納できない場合があります。'],
      ['荷造りの開け閉めは、アルミフレームで', 'ファスナーに頼らないフレーム開閉。歪みに強く、四隅はガードで補強。本体外装：XS・S・MはABS系（PC配合の有無は未確認）、L・XLはPC。フレームはアルミ。'],
      ['移動前に、上下2点をロック', 'XS・S・Mはダイヤルロック、L・XLはTSAロックです。L・XLは検査時にTSA職員が専用キーで解錠・再施錠できます。'],
      ['移動の合間に、USBポートから給電', '側面のポートから手元で給電。内側に市販のモバイルバッテリーを接続して使うパススルー構造で、バッテリーは付属しません。※モバイルバッテリーは航空法規により預け入れ荷物に入れられないため、お預けの際は必ず取り出してください。'],
      ['待ち時間に、カップとスマホの置き場所を', '折りたたみ式のカップ置きと、スマホスタンド対応ハンドル。待ち時間の両手が空く。'],
      ['進む方向に合わせて、8輪が回る', '8輪が荷重を分散し、段差や石畳でも静かに軽く転がる360°回転。'],
      ['立ち止まったら、ホイールをロック', 'キャスター横のレバーを踏み込むと車輪が固定される。坂道や電車内、待ち列でも手を離した拍子に転がり出さない。']
    ],
    colors: {
      silver: { name: 'Silver', hex: '#C9CCD0', sizes: ['XS','S','M','L','XL'],
        imgs: ['media/mer_silver_main.jpg','media/mer_silver_front.jpg','media/mer_silver_side.jpg','media/mer_silver_back.jpg','media/mer_silver_frontopen.jpg','media/mer_silver_open.jpg'],
        vids: {XS:'56731218116774',S:'56731218149542',M:'56731218182310',L:'56731218215078',XL:'56731218247846'} },
      black: { name: 'Black', hex: '#1C1C1E', sizes: ['XS','S','M','L','XL'],
        imgs: ['media/mer_black_main.jpg','media/mer_black_front.jpg','media/mer_black_side.jpg','media/mer_black_back.jpg','media/mer_black_frontopen.jpg','media/mer_black_open.jpg'],
        vids: {XS:'56731218280614',S:'56731218313382',M:'56731218346150',L:'56731218378918',XL:'56731218411686'} },
      white: { name: 'White', hex: '#F4F4F2', sizes: ['XS','S','M','L','XL'],
        imgs: ['media/mer_white_main.jpg','media/mer_white_front.jpg','media/mer_white_side.jpg','media/mer_white_back.jpg','media/mer_white_frontopen.jpg','media/mer_white_open.jpg'],
        vids: {XS:'56731217952934',S:'56731217985702',M:'56731218018470',L:'56731218051238',XL:'56731218084006'} },
      gunmetal: { name: 'Gunmetal Gray', hex: '#4A4D52', sizes: ['XS','S','M','L','XL'],
        imgs: ['media/mer_gunmetal_main.jpg','media/mer_gunmetal_front.jpg','media/mer_gunmetal_side.jpg','media/mer_gunmetal_back.jpg','media/mer_gunmetal_frontopen.jpg','media/mer_gunmetal_open.jpg'],
        vids: {XS:'56731218444454',S:'56731218477222',M:'56731218509990',L:'56731218542758',XL:'56731218575526'} },
      darkgreen: { name: 'Dark Green', hex: '#3E4A40', sizes: ['XS','S','M'],
        imgs: ['media/mer_darkgreen_main.jpg','media/mer_darkgreen_front.jpg','media/mer_darkgreen_side.jpg','media/mer_darkgreen_back.jpg','media/mer_darkgreen_frontopen.jpg','media/mer_darkgreen_open.jpg'],
        vids: {XS:'56815733670054',S:'56815733702822',M:'56815733735590'} },
      whiteorange: { name: 'White / Orange', hex: 'linear-gradient(90deg,#F4F4F2 50%,#E07A3F 50%)', sizes: ['XS','S','M'],
        imgs: ['media/mer_whiteorange_main.jpg','media/mer_whiteorange_front.jpg','media/mer_whiteorange_side.jpg','media/mer_whiteorange_back.jpg','media/mer_whiteorange_frontopen.jpg','media/mer_whiteorange_open.jpg'],
        vids: {XS:'56815733768358',S:'56815733801126',M:'56815733833894'} }
    }
  },
  heritage: {
    key: 'heritage', title: 'HERITAGE', kicker: 'Classic — Aluminum-frame trunk',
    sub: 'クラシックを、現代の手に。', detTitle: '機能を、削ぎ落とさずに。',
    lead: '黒マットのフレームとリベットが、旅の装いを引き締めるトランク型。クラシックな意匠に、鍵を持たないダイヤルロックと8輪キャスターを備えました。',
    benefits: [
      ['旅の装いに、クラシックな意匠', '黒マットのフレームとリベットを組み合わせたトランク型。'],
      ['鍵を持ち歩かずに、施錠する', '3桁のダイヤルロックとサイドラッチで開閉部を固定。'],
      ['荷物の重さを、8輪で支える', '荷重を分散するダブルホイールキャスター。']
    ],
    handle: 'trace-heritage', soldout: false,
    hasOpen: false, hasPack: true, journey: true, sizeFig: true, capCol: false,
    packNote: '容量は外寸からの目安です。デモはMeridian（Silver）で撮影しています。',
    sizeFigSrc: 'media/sizeguide_h.jpg',
    v3sub: 'ドラッグで実物を360°回す。<br>詰めて、旅の荷物が入るかたしかめてください。',
    spinPrefix: 'h_',
    clips: [['media/clip_h_trolley.mp4', 'Trolley — 2本支柱で、まっすぐ伸びる'],
            ['media/clip_h_wheels.mp4', '8 wheels — ダブルホイールキャスター']],
    fallback: { silver:'media/front_h_silver.jpg', white:'media/front_h_white.jpg', black:'media/front_h_black.jpg',
                spacegray:'media/front_h_spacegray.jpg', olive:'media/front_h_olive.jpg', rosegold:'media/front_h_rosegold.jpg',
                winered:'media/front_h_winered.jpg', yellow:'media/front_h_yellow.jpg' },
    prices: {XS:'¥20,800', S:'¥22,800', M:'¥23,800', L:'¥25,800', XL:'¥26,800'},
    table: {
      XS: ['約53×33×21cm', '約2.9kg'], S: ['約58×35×22cm', '約3.2kg'], M: ['約64×39×24cm', '約3.6kg'],
      L: ['約68×43×27cm', '約3.9kg'], XL: ['約70×45×29cm', '約4.1kg']
    },
    dims: {XS:{h:53,cap:33}, S:{h:58,cap:40}, M:{h:64,cap:54}, L:{h:68,cap:71}, XL:{h:70,cap:82}},
    sizeNote: '※寸法は高さ×幅×厚（車輪含む／手測り±1〜2cm）。<br>※機内持込目安は3辺合計115cm以内（座席数100席以上の航空機の一般的な基準）に収まるサイズです。規定は航空会社・機材により異なるため、ご搭乗前に各社の規定をご確認ください。',
    features: [
      ['旅の装いに、クラシックなフレームを', '黒マットの枠とリベットが、古典的なトランクの意匠を今に引き継ぐ。'],
      ['旅先の光に、縦リブの陰影が映る', '丸みのある畝が面剛性を高め、深い陰影を落とす。'],
      ['鍵を持ち歩かずに、ダイヤルで施錠', '3桁の暗証番号式ロックと金属ラッチの二重の締結。鍵は持ち歩かない。'],
      ['移動する荷物を、8輪で支える', '8輪が荷重を分散し、トランク型でも静かに軽く転がる。'],
      ['持ち運ぶ箱の、八隅をガード', '箱型の八隅すべてを金属ガードで保護する。'],
      ['押す時も、引く時も、2本支柱で', '2本支柱でガタつきを抑え、押し引きがまっすぐ決まる。']
    ],
    colors: HO.heritage.colors
  },
  odyssey: {
    key: 'odyssey', title: 'ODYSSEY', kicker: 'Standard — Aluminum-frame suitcase',
    sub: '日常の旅に、必要な機能を。', detTitle: '機能を、削ぎ落とさずに。',
    lead: '荷造りから移動の合間まで、使う機能をひとつに。ファスナーレスのフレーム開閉とカップホルダーを備えた、日常の旅のスタンダード。',
    benefits: [
      ['荷造りの開け閉めは、フレームで', '外周アルミフレームを使った、ファスナーレスの開閉。'],
      ['待ち時間に、カップの置き場所を', '使う時だけ引き出せる、本体同色のカップホルダー。'],
      ['進む方向に合わせて、向きを変える', '360°回転する8輪のダブルスピナーキャスター。']
    ],
    handle: 'trace-odyssey', soldout: true,
    hasOpen: false, hasPack: true, journey: true, sizeFig: true, capCol: false,
    packNote: '容量は外寸からの目安です。デモはMeridian（Silver）で撮影しています。',
    sizeFigSrc: 'media/sizeguide_o.jpg',
    v3sub: 'ドラッグで実物を360°回す。<br>詰めて、旅の荷物が入るかたしかめてください。',
    spinPrefix: 'o_',
    clips: [['media/clip_o_trolley.mp4', 'Trolley — 静かに伸びる、引き手'],
            ['media/clip_o_wheels.mp4', '8 wheels — ダブルスピナーキャスター']],
    fallback: { silver:'media/front_o_silver.jpg', white:'media/front_o_white.jpg', black:'media/front_o_black.jpg',
                gray:'media/front_o_gray.jpg', blue:'media/front_o_blue.jpg', green:'media/front_o_green.jpg',
                pink:'media/front_o_pink.jpg' },
    prices: {XS:'¥20,800', S:'¥22,800', M:'¥23,800', L:'¥25,800', XL:'¥26,800'},
    table: {
      XS: ['約53×33×21cm', '約3.4kg'], S: ['約58×35×22cm', '約3.6kg'], M: ['約60×38×24cm', '約3.8kg'],
      L: ['約63×40×25cm', '約4.2kg'], XL: ['約66×42×27cm', '約4.4kg']
    },
    dims: {XS:{h:53,cap:33}, S:{h:58,cap:40}, M:{h:60,cap:49}, L:{h:63,cap:57}, XL:{h:66,cap:67}},
    sizeNote: '※寸法は高さ×幅×厚（車輪・ハンドル含む／手測り±1〜2cm）。<br>※機内持込目安は、仕入元の案内に基づきXS（20インチ）のみです。S（22インチ）以上は預け入れの案内となります。規定は航空会社・機材により異なるため、ご搭乗前に各社の規定をご確認ください。',
    features: [
      ['荷造りの開け閉めは、アルミフレームで', 'ファスナーレスのフレーム開閉。歪みに強く、佇まいを引き締める。外周はサテン銀の段差仕上げ。'],
      ['持ち運ぶ荷物を、縦リブのシェルで包む', 'ハードシェルの縦リブが面のたわみを抑え、衝撃をシェル全体へ分散する。'],
      ['待ち時間に、カップホルダーを引き出す', '使う時だけ引き出し、閉じれば同色でフラットに消える。'],
      ['移動前に、側面2点をロック', '側面の上下2か所で開閉部を固定します。'],
      ['進む方向に合わせて、8輪が回る', '8輪が荷重を分散し、静かに軽く転がる360°スピナー。'],
      ['持ち運ぶケースの、四隅をガード', '衝撃を最初に受ける四隅を専用ガードで補強。']
    ],
    colors: HO.odyssey.colors
  }
};

/* Shopifyテーマ上では商品ページのhandleから決まる */
var pkey = window.TRACE_V8_PKEY || (new URLSearchParams(location.search)).get('p') || 'meridian';
if (!PRODUCTS[pkey]) pkey = 'meridian';

/* ライブのvariant/価格/在庫を上書き(テーマのみ) */
(function(){
  var L = window.TRACE_V8_PRODUCTS;
  if (!L) return;
  var ORDER = ['XS','S','M','L','XL'];
  function ck(name){
    var k = String(name || '').toLowerCase().replace(/[\s\/]/g, '');
    return k === 'gunmetalgray' ? 'gunmetal' : k;
  }
  Object.keys(L).forEach(function(key){
    var P0 = PRODUCTS[key], lv = L[key];
    if (!P0 || !lv || !lv.variants || !lv.variants.length) return;
    P0.soldout = !lv.variants.some(function(v){ return v.available === true; });
    P0.storeURL = lv.url;
    var prices = {}, vids = {}, compares = {}, availability = {};
    lv.variants.forEach(function(v){
      if (!prices[v.size]) prices[v.size] = v.price;
      if (!compares[v.size] && v.compare) compares[v.size] = v.compare;
      var k = ck(v.color);
      (vids[k] = vids[k] || {})[v.size] = String(v.id);
      (availability[k] = availability[k] || {})[v.size] = v.available === true;
    });
    P0.prices = prices;
    P0.compares = compares;
    Object.keys(P0.colors).forEach(function(k){
      P0.colors[k].vids = vids[k] || {};
      P0.colors[k].available = availability[k] || {};
      P0.colors[k].sizes = ORDER.filter(function(s){ return P0.colors[k].vids[s]; });
    });
  });
})();
var P = PRODUCTS[pkey];
var COLORS = P.colors;
var PRICES = P.prices;
var ALL_SIZES = ['XS','S','M','L','XL'];

/* Shopifyの色・サイズ別在庫を購入可否の正本にする。モックは既存設定を維持。 */
function canBuy(color, size){
  var c = COLORS[color];
  return !!(c && !P.soldout && c.vids[size] && c.sizes.indexOf(size) !== -1 &&
    (!c.available || c.available[size] === true));
}
window.__pdpCanBuy = canBuy;
function syncVariantURL(){
  var url = new URL(location.href);
  if (url.searchParams.has('variant')){
    var id = COLORS[state.color].vids[state.size];
    if (id) url.searchParams.set('variant', id);
    else url.searchParams.delete('variant');
  }
  url.hash = 'c=' + state.color;
  history.replaceState(null, '', url.pathname + url.search + url.hash);
}


/* 二重価格: セール前価格。ライブのcompareAtPriceがあれば優先、無ければ規則(ceil(price/0.9/100)*100)で導出 */
function cmpPrice(s){
  var p = parseInt(String(s).replace(/[^\d]/g, ''), 10);
  if (!p) return '';
  var c = Math.ceil(p / 0.9 / 100) * 100;
  return '¥' + String(c).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
var COMPARES = {};
Object.keys(PRICES).forEach(function(s){
  /* テーマ(ライブ注入あり)ではShopifyのcompareAtPriceのみを正とする。
     compareAtPriceを消せばセール表示も自動で消える。導出はモックプレビュー専用 */
  COMPARES[s] = window.TRACE_V8_PRODUCTS
    ? ((P.compares && P.compares[s]) || '')
    : cmpPrice(PRICES[s]);
});

/* 機内持込・泊数の目安（実データの外寸/容量から決定論で計算） */
function dimsSum(s){
  var m = String((P.table[s] || [''])[0]).match(/(\d+)\s*[×x]\s*(\d+)\s*[×x]\s*(\d+)/);
  return m ? (+m[1] + +m[2] + +m[3]) : 999;
}
function carryOn(s){ return P.key === 'odyssey' ? s === 'XS' : dimsSum(s) <= 115; }   /* ODYSSEYは仕入元の機内持込目安に合わせXSのみ。他モデルは従来の目安を維持。 */
function stayHint(s){
  var cap = P.dims[s] && P.dims[s].cap;
  if (!cap) return '';
  return cap <= 40 ? '1〜3泊' : cap <= 60 ? '3〜5泊' : cap <= 80 ? '5〜7泊' : cap <= 100 ? '7〜10泊' : '10泊〜';
}
function sizeLabel(s){ return s + (carryOn(s) ? ' — 機内持込目安' : ''); }
var ROMAN = ['i','ii','iii','iv','v','vi','vii','viii'];

/* ---------- 商品別の静的テキスト/セクション ---------- */
document.title = P.title + ' — TRACE';
document.getElementById('buyKicker').textContent = P.kicker;
document.getElementById('buyTitle').textContent = P.title;
document.getElementById('buySub').textContent = P.sub;
var buyLead = document.getElementById('buyLead');
if (buyLead) buyLead.textContent = P.lead;
var buyBenefits = document.getElementById('buyBenefits');
if (buyBenefits){
  P.benefits.forEach(function(benefit){
    var li = document.createElement('li');
    var check = document.createElement('span');
    check.className = 'buy__check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';
    var content = document.createElement('div');
    var title = document.createElement('strong');
    title.textContent = benefit[0];
    var body = document.createElement('p');
    body.textContent = benefit[1];
    content.appendChild(title);
    content.appendChild(body);
    li.appendChild(check);
    li.appendChild(content);
    buyBenefits.appendChild(li);
  });
}
document.getElementById('crumbModel').textContent = P.title.charAt(0) + P.title.slice(1).toLowerCase();
document.getElementById('detTitle').textContent = P.detTitle;
document.getElementById('v3Sub').innerHTML = P.v3sub;
var storeURL = 'https://trace-official.com/products/' + P.handle;
/* ヘッダー右はログイン/検索/カートに変更。旧Online Storeリンクは廃止 */
document.querySelectorAll('.hd__nav a[data-model]').forEach(function(a){
  if (a.getAttribute('data-model') === pkey) a.classList.add('is-cur');
});
(function(){
  var rows = document.getElementById('featRows');
  P.features.forEach(function(f, i){
    var div = document.createElement('div');
    div.className = 'feat rv is-in';
    div.innerHTML = '<span class="feat__no">' + ROMAN[i] + '.</span><span class="feat__name"></span><span class="feat__desc"></span>';
    div.children[1].textContent = f[0];
    div.children[2].textContent = f[1];
    rows.appendChild(div);
  });
  var tb = document.getElementById('sizeRows');
  if (!P.capCol) document.getElementById('sizeHead').innerHTML = '<tr><th>Size</th><th>外寸</th><th>重量</th></tr>';
  ALL_SIZES.forEach(function(s){
    var t = P.table[s];
    var tr = document.createElement('tr');
    var cells = '<td>' + s + (carryOn(s) ? '<small>機内持込目安</small>' : '') + '</td><td>' + t[0] + '</td><td>' + t[1] + '</td>';
    if (P.capCol) cells += '<td>' + t[2] + '</td>';
    tr.innerHTML = cells;
    tb.appendChild(tr);
  });
  document.getElementById('sizeNote').innerHTML = P.sizeNote;
  if (!P.sizeFig) document.getElementById('sizeFig').style.display = 'none';
  if (P.sizeFigSrc) document.getElementById('sizeFigImg').src = (window.TRACE_V8_MEDIA && window.TRACE_V8_MEDIA[P.sizeFigSrc]) || P.sizeFigSrc;

  if (!P.journey) document.getElementById('journey').style.display = 'none';
  document.querySelectorAll('#journey .jn__ph img').forEach(function(img){
    var src = img.getAttribute('data-journey-' + pkey);
    var alt = img.getAttribute('data-journey-' + pkey + '-alt');
    if (src) img.src = src;
    if (alt) img.alt = alt;
    if (pkey === 'odyssey' && alt){
      img.parentElement.querySelector('figcaption').textContent = 'Journal — ' + alt.split(' / ')[0];
    }
  });
  var fin = document.getElementById('finBuy');
  fin.querySelector('span').textContent = P.soldout ? 'Sold out — Online Store' : ('Buy ' + P.title.charAt(0) + P.title.slice(1).toLowerCase());

  /* 機能クリップはモデル別素材(media/clip_*.mp4)。無いモデルはセクションごと非表示 */
  var dc = document.getElementById('detClips');
  if (dc){
    var CL = P.clips || [];
    if (!CL.length){ dc.style.display = 'none'; }
    else {
      [['detClipA','detCapA'], ['detClipB','detCapB']].forEach(function(ids, i){
        var v = document.getElementById(ids[0]), cap = document.getElementById(ids[1]);
        if (!v || !CL[i]) return;
        cap.textContent = CL[i][1];
        v.src = (window.TRACE_V8_MEDIA && window.TRACE_V8_MEDIA[CL[i][0]]) || CL[i][0];
        v.setAttribute('autoplay', '');
        v.load();
      });
      /* Safari対策: 画面に入ったら明示再生 */
      if ('IntersectionObserver' in window){
        new IntersectionObserver(function(en, ob){
          if (!en[0].isIntersecting) return;
          dc.querySelectorAll('video').forEach(function(v){
            var p = v.play(); if (p && p.catch) p.catch(function(){});
          });
          ob.disconnect();
        }, { rootMargin: '200px' }).observe(dc);
      }
    }
  }

  /* Models比較表: 現行モデルの強調 + SOLD OUT表記 */
  var cth = document.querySelector('.ctbl th[data-cmp="' + pkey + '"]');
  if (cth) cth.classList.add('is-cur');
  if (PRODUCTS.odyssey.soldout){
    var so = document.querySelector('.cmp__so');
    if (so) so.textContent = '（SOLD OUT）';
  }

  /* FAQ（返品・特商法・商品説明の正データにある事実のみ） */
  var hasUSB = P.features.some(function(f){ return f[0].indexOf('USB') !== -1; });
  var coSizes = ALL_SIZES.filter(function(s){ return P.table[s] && carryOn(s); });
  var faqs = [];
  faqs.push(['機内に持ち込めますか？',
    P.key === 'odyssey' ? '仕入元の案内では、XS（20インチ）が機内持込目安です。S（22インチ）以上は預け入れの案内となります。規定は航空会社・機材により異なるため、ご搭乗前にご利用の航空会社の規定をご確認ください。' : coSizes.length
      ? coSizes.join('・') + 'サイズが、3辺合計115cm以内（座席数100席以上の航空機の一般的な基準）に収まる目安です。規定は航空会社・機材により異なるため、ご搭乗前にご利用の航空会社の規定をご確認ください。'
      : 'XSは3辺合計120cmで、全サイズが一般的な機内持込基準の115cmを超えます。機内持込対応とはご案内していません。ご搭乗前に各航空会社のサイズ・重量規定をご確認ください。']);
  /* 納期は「05 — Shipping」セクションで図解しているためFAQからは外している */
  if (hasUSB) faqs.push(['USBポートにバッテリーは内蔵されていますか？',
    'いいえ。内側に市販のモバイルバッテリーを接続して給電するパススルー構造で、バッテリーは付属しません。モバイルバッテリーは航空法規により預け入れ荷物に入れられないため、スーツケースを預ける際は必ず取り出してください。']);
  if (P.hasOpen) faqs.push(['ノートPCは入りますか？',
    'L・XLは内側のファスナー付きPC収納が17.3インチまでのノートPCに対応します。XS・S・MのPC収納対応寸法は確認できていません。機種の外寸やケースの厚みにより収納できない場合があります。']);
  faqs.push(['傷や個体差はありますか？',
    (P.key === 'meridian' ? 'アルミフレーム部分や外装には、使用に伴い細かな擦り傷が付く場合があります。' : 'アルミニウムは使うほどに細かな擦り傷が付いていく素材です。') + 'また、金具・ステッチ・素材の風合い・色味の差など、製品特性上の軽微な個体差は不良には含まれません。初期不良・破損があった場合は到着後3日以内にご連絡ください。']);
  faqs.push(['サイズが合わなかった場合、交換できますか？',
    'お客様ご都合（色・サイズ感・イメージ違い）による返品・交換はお受けしていません。ご購入前にサイズガイド・360°ビュー・パッキングデモでのご確認をおすすめします。初期不良・誤発送の場合のみ、到着後3日以内のご連絡・7日以内のご返送で交換・返金にて対応します（返送料は当社負担）。']);
  var fl = document.getElementById('faqList');
  faqs.forEach(function(f){
    var d = document.createElement('details');
    var s = document.createElement('summary');
    s.textContent = f[0];
    var a = document.createElement('div');
    a.className = 'faq__a';
    a.textContent = f[1];
    d.appendChild(s); d.appendChild(a);
    fl.appendChild(d);
  });
})();

var state = { color: Object.keys(COLORS)[0], size: 'XS', view: 0 };

/* hash deep-link: product.html?p=heritage#c=black */
(function(){
  var m = (location.hash || '').match(/c=([a-z]+)/);
  if (m && COLORS[m[1]]) state.color = m[1];
  var variant = (new URLSearchParams(location.search)).get('variant');
  if (variant){
    Object.keys(COLORS).some(function(key){
      return Object.keys(COLORS[key].vids).some(function(size){
        if (String(COLORS[key].vids[size]) !== variant) return false;
        state.color = key; state.size = size; return true;
      });
    });
  }
  if (COLORS[state.color].sizes.indexOf(state.size) === -1) state.size = COLORS[state.color].sizes[0] || ALL_SIZES[0];
})();

var pgRail = document.getElementById('pgRail');
var pgDots = document.getElementById('pgDots');
var pgThumbs = document.getElementById('pgThumbs');
var swsEl = document.getElementById('sws');
var szsEl = document.getElementById('szs');

function renderSwatches(){
  swsEl.innerHTML = '';
  Object.keys(COLORS).forEach(function(key){
    var b = document.createElement('button');
    b.className = 'swb' + (key === state.color ? ' is-on' : '');
    b.style.background = COLORS[key].hex;
    b.setAttribute('aria-label', COLORS[key].name);
    b.addEventListener('click', function(){ setColor(key); });
    swsEl.appendChild(b);
  });
}
function renderSizes(){
  szsEl.innerHTML = '';
  ALL_SIZES.forEach(function(s){
    var ok = canBuy(state.color, s);
    var b = document.createElement('button');
    b.className = 'szb' + (s === state.size ? ' is-on' : '') + (ok ? '' : ' is-off');
    b.textContent = s;
    b.disabled = !ok;
    b.setAttribute('aria-disabled', String(!ok));
    if (!ok && COLORS[state.color].sizes.indexOf(s) !== -1) b.setAttribute('aria-label', s + ' — SOLD OUT');
    if (ok) b.addEventListener('click', function(){ setSize(s); });
    szsEl.appendChild(b);
  });
}
/* ギャラリー=色別5ビュー+共有ビュー(内装ディテール等・全色共通) */
function galleryImgs(){
  return COLORS[state.color].imgs.concat(P.sharedImgs || []);
}
function renderThumbs(){
  pgThumbs.innerHTML = '';
  /* 5枚以下ならスマホでも横スクロールにせず1画面に収める */
  pgThumbs.classList.toggle('is-fit', galleryImgs().length <= 5);
  galleryImgs().forEach(function(f, i){
    var d = document.createElement('div');
    d.className = 'pg__th' + (i === state.view ? ' is-on' : '');
    d.setAttribute('data-cursor', 'View');
    var im = document.createElement('img');
    im.src = imgURL(f); im.loading = 'lazy'; im.alt = '';
    d.appendChild(im);
    d.addEventListener('click', function(){ setView(i); });
    pgThumbs.appendChild(d);
  });
  bindCursor(pgThumbs.querySelectorAll('[data-cursor]'));
}
/* メイン画像は全ビューをレールに並べて横スワイプ(スマホ)で送る */
var railLock = false;
function setMain(){
  var imgs = galleryImgs();
  pgRail.innerHTML = '';
  pgDots.innerHTML = '';
  imgs.forEach(function(f, i){
    var s = document.createElement('div');
    s.className = 'pg__slide';
    var im = document.createElement('img');
    im.src = imgURL(f);
    im.alt = 'TRACE ' + P.name;
    if (i > 0) im.loading = 'lazy';
    s.appendChild(im);
    pgRail.appendChild(s);
    var d = document.createElement('i');
    if (i === state.view) d.className = 'is-on';
    pgDots.appendChild(d);
  });
  scrollRail(state.view, 'auto');
}
function scrollRail(i, behavior){
  railLock = true;
  pgRail.scrollTo({ left: i * pgRail.clientWidth, behavior: behavior || 'smooth' });
  setTimeout(function(){ railLock = false; }, behavior === 'auto' ? 60 : 420);
}
function markView(i){
  state.view = i;
  pgThumbs.querySelectorAll('.pg__th').forEach(function(t, k){
    t.classList.toggle('is-on', k === i);
    /* サムネが横レールのときは選択中を視界に入れる(スマホ) */
    if (k === i && pgThumbs.scrollWidth > pgThumbs.clientWidth + 4){
      var l = t.offsetLeft, r = l + t.offsetWidth, s = pgThumbs.scrollLeft, w = pgThumbs.clientWidth;
      if (l < s) pgThumbs.scrollTo({ left: Math.max(0, l - 8), behavior: 'smooth' });
      else if (r > s + w) pgThumbs.scrollTo({ left: r - w + 8, behavior: 'smooth' });
    }
  });
  pgDots.querySelectorAll('i').forEach(function(t, k){ t.classList.toggle('is-on', k === i); });
}
pgRail.addEventListener('scroll', function(){
  if (railLock) return;
  var w = pgRail.clientWidth;
  if (!w) return;
  markView(Math.max(0, Math.min(pgRail.children.length - 1, Math.round(pgRail.scrollLeft / w))));
});
window.addEventListener('resize', function(){ scrollRail(state.view, 'auto'); });
function updateBuy(){
  var c = COLORS[state.color];
  if (c.sizes.indexOf(state.size) === -1) state.size = c.sizes[0] || ALL_SIZES[0];
  document.getElementById('colorName').textContent = c.name;
  document.getElementById('crumbColor').textContent = c.name;
  document.getElementById('sizeName').textContent = sizeLabel(state.size);
  document.getElementById('price').textContent = PRICES[state.size];
  var hasCmp = !!COMPARES[state.size];
  var cp = document.getElementById('cprice');
  if (cp){ cp.textContent = COMPARES[state.size] || ''; cp.style.display = hasCmp ? '' : 'none'; }
  var offEl = document.querySelector('.buy__off');
  if (offEl) offEl.style.display = hasCmp ? '' : 'none';
  document.getElementById('sizeSpec').textContent = P.table[state.size].join(' ・ ');
  var buySpecs = document.getElementById('buySpecs');
  if (buySpecs){
    var specs = '';
    if (P.key === 'meridian'){
      specs = ['L','XL'].indexOf(state.size) !== -1
        ? '外装はPC、フレームはアルミ。TSAロックを装備。PC収納は17.3インチまで対応しますが、機種の外寸・ケースの厚みにより入らない場合があります。'
        : '外装はABS系（PC配合は未確認）、フレームはアルミ。ダイヤルロックを装備し、TSA認証は未確認です。PC収納の対応寸法は確認できていません。';
      specs += ' 全サイズが一般的な機内持込基準（3辺合計115cm）を超えます。各航空会社の規定をご確認ください。';
    } else if (P.key === 'heritage'){
      specs = '黒マットのフレームとリベット、3桁ダイヤルロック＋サイドラッチ、8輪のダブルホイールキャスター。八隅に金属ガードを備えています。';
    } else {
      specs = '外周アルミフレームによるファスナーレス開閉、側面2点ロック、8輪のダブルスピナーキャスター。側面に折りたたみカップホルダーを備えています。';
    }
    buySpecs.textContent = '選択サイズ：' + state.size + '。' + specs;
  }
  var stay = stayHint(state.size);
  document.getElementById('sizeHint').textContent =
    (stay ? '荷物の目安：' + stay + 'の旅' : '') +
    (carryOn(state.size) ? (stay ? ' ・ ' : '') + '機内持込目安サイズ' : '') +
    (P.key === 'meridian' && ['XS','S','M'].indexOf(state.size) !== -1
      ? '。XS・S・MのTSA認証は未確認です。写真のTSAマークは認証を保証しません。' : '');
  var available = canBuy(state.color, state.size);
  var link = (P.storeURL || storeURL) + '?variant=' + c.vids[state.size];
  var btn = document.getElementById('buyBtn');
  var form = document.getElementById('tv8Form');
  var vidInput = document.getElementById('tv8Vid');
  if (vidInput) vidInput.value = available ? c.vids[state.size] : '';
  if (!btn.dataset.availableLabel) btn.dataset.availableLabel = btn.querySelector('span').textContent;
  btn.querySelector('span').textContent = available ? btn.dataset.availableLabel : 'SOLD OUT — 再入荷を待つ';
  btn.style.opacity = available ? '' : '.55';
  btn.setAttribute('aria-disabled', String(!available));
  if (form) btn.disabled = !available;
  else if (available) btn.href = link;
  else btn.removeAttribute('href');
  var finBuy = document.getElementById('finBuy');
  finBuy.setAttribute('aria-disabled', String(!available));
  if (available) finBuy.href = link;
  else finBuy.removeAttribute('href');
  /* モバイル固定バーを購入パネルと同期 */
  var mp = document.getElementById('mbarPrice');
  if (mp){
    mp.textContent = PRICES[state.size];
    var mc = document.getElementById('mbarCmp');
    if (mc){ mc.textContent = COMPARES[state.size] || ''; mc.style.display = COMPARES[state.size] ? '' : 'none'; }
    document.getElementById('mbarSel').textContent = c.name + ' / ' + state.size;
    var mb = document.getElementById('mbarBtn');
    if (!mb.dataset.availableLabel) mb.dataset.availableLabel = mb.querySelector('span').textContent;
    mb.disabled = !available;
    mb.setAttribute('aria-disabled', String(!available));
    mb.querySelector('span').textContent = available ? mb.dataset.availableLabel : 'SOLD OUT';
  }
}
function setColor(key){
  if (!COLORS[key]) return;
  state.color = key; state.view = 0;
  if (COLORS[key].sizes.indexOf(state.size) === -1) state.size = COLORS[key].sizes[0] || ALL_SIZES[0];
  syncVariantURL();
  renderSwatches(); renderSizes(); renderThumbs(); setMain(); updateBuy();
  if (window.T3D) window.T3D.sync(state.color, state.size);
}
function setSize(s){
  if (!canBuy(state.color, s)) return;
  state.size = s; syncVariantURL(); renderSizes(); updateBuy();
  if (window.T3D) window.T3D.sync(state.color, state.size);
}

/* Enterキー、固定バー、リンク経由も同じ在庫条件で守る。 */
var purchaseForm = document.getElementById('tv8Form');
if (purchaseForm) purchaseForm.addEventListener('submit', function(e){
  if (!canBuy(state.color, state.size)){ e.preventDefault(); updateBuy(); }
});
['buyBtn', 'mbarBtn', 'finBuy'].forEach(function(id){
  var el = document.getElementById(id);
  if (el) el.addEventListener('click', function(e){
    if (!canBuy(state.color, state.size)){ e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
});

window.__pdpState = state;
window.__pdpProduct = P;
window.__pdpSetSize = setSize;   /* ビューア側のサイズ切替から呼ぶ */
window.__pdpSizes = ALL_SIZES;
function setView(i){
  markView(i);
  scrollRail(i);
}

/* ---------- custom cursor ---------- */
var cur, curTxt;
function bindCursor(list){
  if (!fine || !cur) return;
  list.forEach(function(el){
    el.addEventListener('mouseenter', function(){
      cur.classList.add('is-zoom'); curTxt.textContent = el.getAttribute('data-cursor');
    });
    el.addEventListener('mouseleave', function(){ cur.classList.remove('is-zoom'); });
  });
}
if (fine){
  cur = document.querySelector('.cur');
  curTxt = cur.querySelector('.cur__txt');
  var dot = cur.querySelector('.cur__dot');
  var ring = cur.querySelector('.cur__ring');
  var mx = -100, my = -100, rx = -100, ry = -100;
  window.addEventListener('mousemove', function(e){ mx = e.clientX; my = e.clientY; });
  (function loop(){
    rx += (mx - rx) * .16; ry += (my - ry) * .16;
    dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
    requestAnimationFrame(loop);
  })();
}

/* init */
renderSwatches(); renderSizes(); renderThumbs(); setMain(); updateBuy();

/* モバイル固定購入バー: 購入パネルを通り過ぎたら表示 */
(function(){
  var bar = document.getElementById('mbar');
  var buy = document.querySelector('.buy');
  if (!bar || !buy) return;
  document.getElementById('mbarBtn').addEventListener('click', function(){
    document.getElementById('buyBtn').click();
  });
  if (!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(es){
    var e = es[0];
    var passed = !e.isIntersecting && e.boundingClientRect.bottom < 0;
    bar.classList.toggle('is-on', passed);
    bar.setAttribute('aria-hidden', String(!passed));
  }, {threshold: 0}).observe(buy);
})();
})();

/* ---------- 360°ビューア: 実物写真ターンテーブル + 前面オープン実写 + 実写パッキングデモ ---------- */
(function(){
'use strict';
var stage = document.getElementById('v3Stage');
if (!stage || !window.__pdpProduct) return;
var P = window.__pdpProduct;
var spinImg = document.getElementById('v3Spin');
var spinWrap = document.getElementById('v3SpinWrap');
var openPh = document.getElementById('v3OpenPh');
var packPh = document.getElementById('v3PackPh');
var loadEl = document.getElementById('v3Load');
var hintEl = document.getElementById('v3Hint');
var stateEl = document.getElementById('v3State');
var vszEl = document.getElementById('v3Sizes');
var openBtn = document.getElementById('v3Open');
var cmpBtn = document.getElementById('v3CmpBtn');
var resetBtn = document.getElementById('v3Reset');
var itemsEl = document.getElementById('v3Items');
var barEl = document.getElementById('v3Bar');
var usedEl = document.getElementById('v3Used');
var capEl = document.getElementById('v3Cap');
var noteEl = document.getElementById('v3Note');
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

var SPIN_N = 48, SP_COLS = 8, SP_ROWS = 6;
var CDN = 'https://cdn.shopify.com/s/files/1/0747/7490/4998/files/';
var COLORS = P.colors;
var DIMS = P.dims;
var FALLBACK = P.fallback;
var MAXH = 80;   /* ビューア描画用の高さ基準。商品の実寸はDIMSを参照。 */

/* 素材ごとの被写体位置(描画される画像の高さに対する比率・実測値 gen/measure)
   b=本体の高さ(伸ばしたトロリーを除く) / t=被写体の上端 / g=接地線 */
var FIT = {
  'silver':{b:.622,t:.080,g:.959}, 'black':{b:.602,t:.078,g:.930}, 'white':{b:.577,t:.069,g:.931},
  'gunmetal':{b:.612,t:.078,g:.933}, 'darkgreen':{b:.601,t:.078,g:.929}, 'whiteorange':{b:.614,t:.073,g:.942},
  'h_silver':{b:.692,t:.249,g:.961}, 'h_white':{b:.599,t:.316,g:.929}, 'h_black':{b:.591,t:.316,g:.922},
  'h_spacegray':{b:.648,t:.042,g:.944}, 'h_olive':{b:.610,t:.313,g:.937}, 'h_rosegold':{b:.594,t:.316,g:.927},
  'h_winered':{b:.594,t:.318,g:.928}, 'h_yellow':{b:.616,t:.291,g:.924},
  'o_silver':{b:.601,t:.316,g:.931}, 'o_white':{b:.602,t:.318,g:.936}, 'o_black':{b:.600,t:.316,g:.941},
  'o_gray':{b:.603,t:.318,g:.932}, 'o_blue':{b:.594,t:.089,g:.928}, 'o_green':{b:.591,t:.318,g:.924},
  'o_pink':{b:.602,t:.318,g:.936}
};
var FIT_DEF  = {b:.60,t:.30,g:.93};
var FIT_OPEN = {b:.60,t:.311,g:.926};   /* mer_*_frontopen.jpg (1400x1750) */
var TARGET = .64;    /* 本体の高さ=ステージ高さの64%を基準にフレームへ収める */
var TOPPAD = .03;    /* 上端に残す余白 */
var BASE   = .93;    /* 接地線をステージ高さの93%に固定(素材差を吸収) */
var SMIN   = .88;    /* 最小サイズでも基準の88%。実寸の比較は「サイズ比較」モードで見せる */
var PACK_ZOOM = 1.15;
var HUMAN_H = 170;   /* サイズ比較の人物(cm) */
var HUMAN_FILL = .85;
var HUMAN_X = .30;   /* 人物の中心(ステージ幅比) */
var CASE_DX = .08;   /* ケースを右へずらす量(ステージ幅比) */
var cmpOn = false;
var ITEMS = [
  { id:'wear',   label:'衣類（3日分）',    l:14 },
  { id:'shoes',  label:'シューズ',         l:6 },
  { id:'pc',     label:'ノートPC',         l:3 },
  { id:'gadget', label:'ガジェットポーチ', l:3 },
  { id:'camera', label:'カメラ',           l:5 },
  { id:'pouch',  label:'洗面ポーチ',       l:2 },
  { id:'gift',   label:'おみやげ',         l:8 },
];

var color = (window.__pdpState && window.__pdpState.color) || Object.keys(COLORS)[0];
var size = (window.__pdpState && window.__pdpState.size) || 'XS';
var frame = 0, mode = 'spin', packedCount = 0, started = false, userTouched = false;
/* パッキング写真はサイズ別フォルダ(sz_xs〜sz_xl)。実寸比は画像側に焼き込み済み(ズームtransform無し)
   撮影基準はMeridian実寸。他モデルは近似で縮小のみ(拡大しない=劣化防止) */
var MER_H = { XS: 55, S: 65, M: 69, L: 75, XL: 80 };
function packSrc(k){ return MU('media/pack/sz_' + size.toLowerCase() + '/pk' + k + '.jpg'); }
function packRel(){ return Math.min(1, DIMS[size].h / MER_H[size]); }
var frames = {};     /* color -> [Image] */
var okCount = {};    /* color -> loaded count */
var spinDead = {};   /* color -> true = フレーム欠落で静止画フォールバック */

/* 商品別: 前開き/パッキングの有無 */
if (!P.hasOpen){ openBtn.style.display = 'none'; }
if (!P.hasPack){ document.getElementById('v3PackSec').style.display = 'none'; }
if (P.packNote){
  document.getElementById('v3Foot').textContent =
    '※360°ビューは実物写真をもとにしたイメージです。' + P.packNote +
    'ビューア内のサイズ切替は見やすさを優先しており、XS〜XLの見た目の大きさは同一縮尺ではありません。' +
    '実寸は下のSIZE GUIDEの表でご確認ください（「サイズ比較」の人物は身長170cmの目安）。';
}

/* media/… はテーマ上でasset_urlに差し替わる */
function MU(p){ var m = window.TRACE_V8_MEDIA; return (m && m[p]) || p; }
function spriteSrc(c){ return MU('media/sprite/' + (P.spinPrefix || '') + c + '.jpg'); }

/* --- 表示スケール ---
   通常: 素材ごとの被写体比を打ち消して同じ大きさに揃え、フレームいっぱいに収める。
        サイズ差は88〜100%に圧縮(実寸の差は「サイズ比較」モードで人物と並べて見せる)。
   サイズ比較: 身長170cmと同じ縮尺で並べる(cm実寸)。 */
function sizeFactor(){
  var hs = [], k;
  for (k in DIMS) if (DIMS.hasOwnProperty(k)) hs.push(DIMS[k].h);
  var mn = Math.min.apply(null, hs), mx = Math.max.apply(null, hs);
  return (mx > mn) ? SMIN + (1 - SMIN) * (DIMS[size].h - mn) / (mx - mn) : 1;
}
function imgH(el, dflt){
  /* object-fit:contain で実際に描画される画像の高さ(px) */
  var H = stage.clientHeight, W = stage.clientWidth;
  var r = (el && el.naturalWidth && el.naturalHeight) ? (el.naturalWidth / el.naturalHeight) : dflt;
  return r ? Math.min(H, W / r) : H;
}
function place(el, f, s, ih, dx){
  var H = stage.clientHeight;
  var gy = (H - ih) / 2 + f.g * ih;              /* 要素座標での接地線 */
  el.style.transformOrigin = '50% ' + gy.toFixed(1) + 'px';
  el.style.transform = 'translate(' + (dx || 0).toFixed(1) + 'px,' + (BASE * H - gy).toFixed(1) + 'px) ' +
                       'scale(' + s.toFixed(3) + ')';
}
function fitScale(f, ih, factor){
  var H = stage.clientHeight;
  return Math.min(TARGET * H / (f.b * ih), (BASE - TOPPAD) * H / ((f.g - f.t) * ih)) * factor;
}
function applyScale(){
  var H = stage.clientHeight, W = stage.clientWidth;
  var fSpin = FIT[(P.spinPrefix || '') + color] || FIT_DEF;
  var factor = sizeFactor();
  spinImg.style.transition = 'transform .55s cubic-bezier(.22,1,.36,1)';
  openPh.style.transition = 'transform .55s cubic-bezier(.22,1,.36,1), opacity .45s ease';

  if (cmpOn){
    var ppc = HUMAN_FILL * H / HUMAN_H;                 /* px per cm */
    var sc = (DIMS[size].h * ppc) / (fSpin.b * H);
    place(spinImg, fSpin, sc, H, W * CASE_DX);
    layoutCmp(ppc);
  } else {
    place(spinImg, fSpin, fitScale(fSpin, H, factor), H, 0);
    var ih = imgH(openPh, 0.8);
    place(openPh, FIT_OPEN, fitScale(FIT_OPEN, ih, factor), ih, 0);
  }
  /* パッキングはサイズ別写真に実寸比が焼き込み済み。構図を保ったまま一律ズームのみ */
  var pr = packRel() * PACK_ZOOM;
  packPh.style.transformOrigin = '50% 50%';
  packPh.style.transform = 'scale(' + pr.toFixed(3) + ')';
}

/* --- サイズ比較(人物シルエット)のレイアウト --- */
var cmpLayer = document.getElementById('v3CmpLayer');
var cmpFig = document.getElementById('v3CmpFig');
var cmpHumanLbl = document.getElementById('v3CmpHuman');
var cmpCaseLbl = document.getElementById('v3CmpCase');
var cmpBase = document.getElementById('v3CmpBase');
function layoutCmp(ppc){
  if (!cmpLayer) return;
  var H = stage.clientHeight, W = stage.clientWidth;
  var hh = HUMAN_H * ppc, hw = hh * 0.3;                 /* svg viewBox 60x200 */
  var hx = W * HUMAN_X, baseY = BASE * H;
  cmpFig.style.width = hw.toFixed(1) + 'px';
  cmpFig.style.height = hh.toFixed(1) + 'px';
  cmpFig.style.left = (hx - hw / 2).toFixed(1) + 'px';
  cmpFig.style.top = (baseY - hh).toFixed(1) + 'px';
  cmpBase.style.top = baseY.toFixed(1) + 'px';
  cmpHumanLbl.style.left = hx.toFixed(1) + 'px';
  cmpHumanLbl.style.top = (baseY + 12).toFixed(1) + 'px';
  cmpCaseLbl.style.left = (W * (0.5 + CASE_DX)).toFixed(1) + 'px';
  cmpCaseLbl.style.top = (baseY + 12).toFixed(1) + 'px';
  cmpCaseLbl.textContent = size + ' — 高さ' + DIMS[size].h + 'cm';
}
function setCmp(on){
  cmpOn = !!on;
  stage.classList.toggle('is-cmp', cmpOn);
  cmpLayer.setAttribute('aria-hidden', String(!cmpOn));
  cmpBtn.classList.toggle('is-on', cmpOn);
  hintEl.style.opacity = cmpOn ? '0' : '';
  if (cmpOn && mode !== 'spin') setMode('spin');
  applyScale();
}

function loadColor(c){
  if (frames[c]) return;
  frames[c] = 'loading';
  var im = new Image();
  im.onload = function(){
    frames[c] = im.src; okCount[c] = SPIN_N;
    if (c === color){ loadEl.classList.add('is-off'); draw(); }
  };
  im.onerror = function(){
    spinDead[c] = true; frames[c] = null;
    if (c === color){
      spinImg.classList.add('is-still');
      spinImg.style.backgroundImage = 'url("' + MU(FALLBACK[c]) + '")';
      loadEl.classList.add('is-off');
      hintEl.textContent = '色・サイズは購入パネルと連動';
    }
  };
  im.src = spriteSrc(c);
}

/* --- 縦回転(カメラ仰角の弧)。スプライトがある色だけ有効・無ければ縦ドラッグは無視 --- */
var V_EYE = 0;                  /* 弧の先頭=正面(横リングと同じ目線) */
var vsheets = {};               /* color -> url | 'loading' | null(無し) */
var vframe = V_EYE;
function vSrc(c){ return MU('media/sprite/v_' + c + '.jpg'); }
/* 縦回転は2026-08-26に停止: 素材が旧造形のうえ、新造形での再生成は弧の終端が破綻する
   (seedanceが天面を創作しフレーム外に流れる)。横360°のみで運用する。 */
var V_ENABLED = false;
function loadV(c){
  if (!V_ENABLED){ vsheets[c] = null; return; }
  if (vsheets[c] !== undefined) return;
  vsheets[c] = 'loading';
  var im = new Image();
  im.onload = function(){
    vsheets[c] = im.src;
    if (c === color){
      stage.style.touchAction = 'none';   /* 縦ドラッグをスクロールに取られない */
      var cue = document.getElementById('v3Cue');
      if (cue && !cue.classList.contains('is-off')) cue.innerHTML = '<span>360°</span>縦・横にドラッグで回す';
    }
  };
  im.onerror = function(){ vsheets[c] = null; };
  im.src = vSrc(c);
}
function vReady(){ var u = vsheets[color]; return !!u && u !== 'loading'; }
function drawV(){
  var url = vsheets[color];
  if (!url || url === 'loading') return;
  spinImg.classList.remove('is-still');
  spinImg.style.backgroundImage = 'url("' + url + '")';
  var col = vframe % SP_COLS, row = Math.floor(vframe / SP_COLS);
  spinImg.style.backgroundPosition = (col * 100 / (SP_COLS - 1)) + '% ' + (row * 100 / (SP_ROWS - 1)) + '%';
}

function draw(){
  if (spinDead[color]){
    spinImg.classList.add('is-still');
    spinImg.style.backgroundImage = 'url("' + MU(FALLBACK[color]) + '")';
    return;
  }
  var url = frames[color];
  if (!url || url === 'loading') return;
  spinImg.classList.remove('is-still');
  spinImg.style.backgroundImage = 'url("' + url + '")';
  var col = frame % SP_COLS, row = Math.floor(frame / SP_COLS);
  spinImg.style.backgroundPosition = (col * 100 / (SP_COLS - 1)) + '% ' + (row * 100 / (SP_ROWS - 1)) + '%';
}

function setMode(m){
  mode = m;
  stage.classList.toggle('is-open', m === 'open');
  stage.classList.toggle('is-pack', m === 'pack');
  openBtn.textContent = (m === 'open') ? '閉じる' : '前を開ける';
  openBtn.classList.toggle('is-on', m === 'open');
  if (m === 'spin') noteEl.textContent = '';
}

/* --- ドラッグ回転(タップでは開き/パッキングを閉じない。実ドラッグ開始時のみspinへ)
       横=360°回転(ループ+慣性) / 縦=カメラ仰角の弧(クランプ・v_スプライトがある色のみ) --- */
var dragging = false, armed = false, axis = 'yaw';
var startX = 0, startY = 0, startFrame = 0, startV = 0, vel = 0, lastX = 0, lastT = 0;
stage.addEventListener('pointerdown', function(e){
  userTouched = true;
  var cue = document.getElementById('v3Cue');
  if (cue) cue.classList.add('is-off');
  if (mode === 'pack') return;   /* パッキング表示中はドラッグ無効(回転はリセット後) */
  if (spinDead[color] && mode === 'spin' && !vReady()) return;
  armed = true; dragging = false;
  startX = e.clientX; startY = e.clientY; startFrame = frame; startV = vframe;
  vel = 0; lastX = e.clientX; lastT = performance.now();
  stage.setPointerCapture(e.pointerId);
});
stage.addEventListener('pointermove', function(e){
  if (!armed) return;
  if (!dragging){
    var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
    if (dx < 8 && dy < 8) return;   /* タップ判定のしきい値 */
    axis = (dy > dx && vReady()) ? 'pitch' : 'yaw';
    if (axis === 'yaw' && dy > dx && dx < 8) return;   /* 縦素材なしの縦スワイプ=ページスクロールに譲る */
    dragging = true;
    if (mode !== 'spin') setMode('spin');
    if (axis === 'yaw' && spinDead[color]){ dragging = false; armed = false; return; }
    stage.classList.add('is-drag');
  }
  if (axis === 'pitch'){
    var perV = (stage.clientHeight * 1.2) / SPIN_N;   /* 高さ1.2回分で弧全域 */
    var dv = Math.round((startY - e.clientY) / perV); /* 上へドラッグ=上から見る */
    var nv = Math.min(SPIN_N - 1, Math.max(0, startV + dv));
    if (nv !== vframe){ vframe = nv; drawV(); }
    return;
  }
  var per = stage.clientWidth / SPIN_N;   /* 幅1回で1回転 */
  var d = Math.round((e.clientX - startX) / per);
  var nf = ((startFrame + d) % SPIN_N + SPIN_N) % SPIN_N;
  if (nf !== frame){ frame = nf; draw(); }
  var now = performance.now();
  if (now - lastT > 16){ vel = (e.clientX - lastX) / (now - lastT); lastX = e.clientX; lastT = now; }
});
function endDrag(){
  armed = false;
  if (!dragging) return;
  dragging = false; stage.classList.remove('is-drag');
  if (axis === 'pitch') return;               /* 縦は慣性なし(弧の端でクランプ) */
  if (Math.abs(vel) > .25 && !reduced){       /* 慣性 */
    var v = vel * 14;
    (function momentum(){
      if (dragging || Math.abs(v) < .4) return;
      frame = ((frame + (v > 0 ? 1 : -1)) % SPIN_N + SPIN_N) % SPIN_N;
      draw(); v *= .88;
      setTimeout(momentum, 34);
    })();
  }
}
stage.addEventListener('pointerup', endDrag);
stage.addEventListener('pointercancel', endDrag);

/* --- アイドル自動回転(初操作まで) --- */
function autoSpin(){
  if (userTouched || reduced || spinDead[color]) return;
  if (mode === 'spin' && okCount[color] >= SPIN_N){ frame = (frame + 1) % SPIN_N; draw(); }
  setTimeout(autoSpin, 120);
}

/* --- 前面オープン(実写) --- */
function openSrc(){
  /* media/… はテーマ上でasset_urlへ差し替えが要る(MU)。CDN直ファイル名はそのまま */
  var f = COLORS[color] && COLORS[color].imgs[4];
  return f ? (f.indexOf('/') > -1 ? MU(f) : CDN + f) : '';
}
openBtn.addEventListener('click', function(){
  if (mode === 'open'){ setMode('spin'); return; }
  if (cmpOn) setCmp(false);
  openPh.src = openSrc();
  openPh.onload = function(){ applyScale(); };
  setMode('open');
  applyScale();
  noteEl.textContent = '';
});

cmpBtn.addEventListener('click', function(){ setCmp(!cmpOn); });

resetBtn.addEventListener('click', function(){
  packedCount = 0; frame = 0;
  if (cmpOn) setCmp(false);
  setMode('spin'); draw(); renderItems(); updateGauge();
  noteEl.textContent = '';
});

/* ステージ寸法が変わるとpx基準の配置がずれるので再計算 */
var rzT = null;
window.addEventListener('resize', function(){
  clearTimeout(rzT);
  rzT = setTimeout(function(){ if (started) applyScale(); }, 180);
});

/* --- パッキングデモ(実物写真シーケンス・上から順に詰める) --- */
function cap(){ return DIMS[size].cap || 45; }
function used(){
  var s = 0;
  for (var i = 0; i < packedCount; i++) s += ITEMS[i].l;
  return s;
}
function updateGauge(){
  if (!P.hasPack) return;
  var u = used(), c = cap();
  barEl.style.width = Math.min(100, u / c * 100) + '%';
  usedEl.textContent = u + 'L';
  capEl.textContent = c + 'L';
}
function renderItems(){
  if (!P.hasPack) return;
  itemsEl.innerHTML = '';
  ITEMS.forEach(function(it, i){
    var b = document.createElement('button');
    b.type = 'button';
    var cls = 'v3item';
    if (i < packedCount - 1) cls += ' is-in';
    else if (i === packedCount - 1) cls += ' is-last';
    else if (i > packedCount) cls += ' is-ng';
    b.className = cls;
    var tag = (i === packedCount - 1) ? '取り出す' : it.l + 'L';
    b.innerHTML = '<span>' + it.label + '</span><b>' + tag + '</b>';
    if (i === packedCount) b.addEventListener('click', function(){ packNext(); });
    if (i === packedCount - 1) b.addEventListener('click', function(){ unpackLast(); });
    itemsEl.appendChild(b);
  });
}
function showPack(){
  packPh.src = packSrc(packedCount);
  if (cmpOn) setCmp(false);
  setMode('pack');
  applyScale();
  var pre = (P.key === 'meridian' && color !== 'silver') ? 'デモはSilverで撮影しています。' : '';
  noteEl.textContent = pre + (packedCount === ITEMS.length ? ' 全部入りました。' : '');
}
function packNext(){
  if (packedCount >= ITEMS.length) return;
  if (used() + ITEMS[packedCount].l > cap()){
    noteEl.textContent = '入りきりません。サイズを上げてみてください。';
    return;
  }
  packedCount++;
  showPack(); renderItems(); updateGauge();
}
function unpackLast(){
  if (packedCount === 0) return;
  packedCount--;
  showPack(); renderItems(); updateGauge();
}
function preloadPack(){
  if (!P.hasPack) return;
  for (var k = 0; k <= ITEMS.length; k++){ var im = new Image(); im.src = packSrc(k); }
}

/* --- ビューア内のサイズ切替(購入パネルと同じ状態を動かす) --- */
function renderVSizes(){
  if (!vszEl) return;
  var all = window.__pdpSizes || ['XS', 'S', 'M', 'L', 'XL'];
  var avail = (COLORS[color] && COLORS[color].sizes) || all;
  vszEl.innerHTML = '';
  all.forEach(function(s){
    var ok = avail.indexOf(s) !== -1 && (!window.__pdpCanBuy || window.__pdpCanBuy(color, s));
    var b = document.createElement('button');
    b.type = 'button';
    b.disabled = !ok;
    b.setAttribute('aria-disabled', String(!ok));
    b.className = 'v3sz' + (s === size ? ' is-on' : '') + (ok ? '' : ' is-off');
    b.textContent = s;
    if (ok) b.addEventListener('click', function(){
      if (window.__pdpSetSize) window.__pdpSetSize(s);
    });
    vszEl.appendChild(b);
  });
}
renderVSizes();

/* --- 購入パネルと連動 --- */
window.T3D = {
  sync: function(c, s){
    var colorChanged = (c !== color);
    var sizeChanged = (s !== size);
    color = c; size = s;
    stateEl.textContent = COLORS[color].name + ' / ' + size;
    applyScale();
    if (colorChanged && mode !== 'spin') setMode('spin');
    if (colorChanged){
      loadColor(color);
      loadV(color);
      stage.style.touchAction = vReady() ? 'none' : 'pan-y';
      draw();
      if (mode === 'open') openPh.src = openSrc();
    }
    if (sizeChanged){
      /* サイズ変更=パッキングデモを強制リセット(詰め直し) */
      packedCount = 0;
      if (mode === 'pack') setMode('spin');
      noteEl.textContent = '';
      preloadPack();
    }
    renderItems(); updateGauge(); renderVSizes();
  }
};

/* --- 遅延初期化 --- */
function start(){
  if (started) return;
  started = true;
  loadColor(color);
  loadV(color);
  stateEl.textContent = COLORS[color].name + ' / ' + size;
  applyScale();
  renderItems(); updateGauge(); preloadPack();
  setTimeout(autoSpin, 900);
}
if ('IntersectionObserver' in window){
  var io = new IntersectionObserver(function(en){
    if (en[0].isIntersecting){ start(); io.disconnect(); }
  }, { rootMargin: '500px' });
  io.observe(stage);
} else { start(); }
})();
